import Cookies from 'js-cookie';

export const FBC_HEADER = 'X-FB-FBC';
export const FBC_COOKIE = '_fbc';

// Forwards Meta's _fbc browser cookie value as a request header so it reaches
// the Reverb backend through graphql-gateway, which strips cookies on
// upstream subgraph requests. Reverb reads it from Reverb::Context.fb_fbc and
// sends it on Facebook CAPI purchase events.
export function fbcHeader() {
  const fbc = Cookies.get(FBC_COOKIE);
  if (!fbc) return {};

  return {
    [FBC_HEADER]: fbc,
  };
}
